import { FloatingFormItem } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { BankAccountSettingsFormValues } from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { Button, Col, Form, FormInstance, Input, Row } from 'antd';
import { Plus, Trash2 } from 'react-feather';

interface Props {
  form: FormInstance<BankAccountSettingsFormValues>;
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipMessagesForm({ form }: Props) {
  return (
    <Form form={form} name="bankAccountConfigBullet">
      <Form.List name="messages" initialValue={[]}>
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map((fieldItem, index) => (
                <Row align="top" gutter={[12, 12]} style={{ marginBottom: 12 }}>
                  <Col span={10}>
                    <FloatingFormItem
                      parentFieldName="messages"
                      fieldKey={[fieldItem.key, 'titleMessage']}
                      name={[fieldItem.name, 'titleMessage']}
                      label={`Titulo mensagem 0${index + 1}`}
                      style={{ margin: 0 }}
                    >
                      <Input.TextArea maxLength={80} showCount />
                    </FloatingFormItem>
                  </Col>

                  <Col>
                    {fieldItem.key !== undefined ? (
                      <Button
                        type="link"
                        style={{ height: 48 }}
                        onClick={() => remove(index)}
                      >
                        <AntdFeatherIcon icon={<Trash2 />} />
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              ))}

              <Form.Item style={{ marginTop: 12 }}>
                <Button
                  type="link"
                  disabled={fields?.length === 9}
                  onClick={() => add({ titleMessage: '' })}
                  icon={<AntdFeatherIcon icon={<Plus />} size={12} />}
                >
                  Adicionar Mensagem
                </Button>
              </Form.Item>
            </>
          );
        }}
      </Form.List>
    </Form>
  );
}
